module.exports = __webpack_public_path__ + "media/superlogica-logo.02f32a6b.png";